export default __webpack_public_path__ + "static/media/modelCubeLogo.fb96786a.png";